module.exports = __webpack_public_path__ + "img/floor_OG5.efc00615.svg";